"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderAdjustItem = exports.parseRenderAdjustItem = exports.LOCKED_QUOTE = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const ShareRatioUtils_1 = require("../../../TradeUtils/ShareRatioUtils");
const interfaces_1 = require("./interfaces");
const react_1 = require("react");
const TradeAPILib_1 = require("TradeAPILib");
exports.LOCKED_QUOTE = "USDT";
// const isGFHedgeOrderWithTwoDirection = (order: ExchangeOrder) => {
//     if (order.orderType !== ExchangeOrderType.gridV4FuturesHedgeGrid) {
//         return false;
//     }
//     const innerOrder = order.exchangeGridV4FuturesHedgeGridOrder as ExchangeGridV4FuturesHedgeGridOrder;
//     return innerOrder.long && innerOrder.short;
// };
const parseRenderAdjustItem = (order, item, symbolInfo, $st, $num, quoteUsdtSymbolInfo, useShortTitle) => {
    let subExtra = false;
    const typeTitle = (() => {
        var _a, _b;
        switch (item.type) {
            case interfaces_1.AdjustParamsType.invest_in: {
                if ((_a = order.exchangeGridV4FuturesOrder) === null || _a === void 0 ? void 0 : _a.locked_order) {
                    return $st("grid_position_locked_add_position");
                }
                return $st("grid_position_add_position");
            }
            case interfaces_1.AdjustParamsType.invest_out: {
                return $st("grid_futures_reduce_position");
            }
            case interfaces_1.AdjustParamsType.open: {
                switch (order.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid: {
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.hedge) {
                            return $st("hedge_grid_long_short_open_title");
                        }
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.long) {
                            return $st("hedge_grid_postion_record_open_long_title");
                        }
                        return $st("hedge_grid_postion_record_open_short_title");
                    }
                    default: {
                        if ((_b = order.exchangeGridV4FuturesOrder) === null || _b === void 0 ? void 0 : _b.locked_order) {
                            return $st("grid_futures_locked_open_order");
                        }
                        return $st("grid_position_open");
                    }
                }
            }
            case interfaces_1.AdjustParamsType.close: {
                switch (order.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid: {
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.hedge) {
                            return $st("hedge_grid_long_short_close_title");
                        }
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.long) {
                            return $st("hedge_grid_postion_record_close_long_title");
                        }
                        return $st("hedge_grid_postion_record_close_short_title");
                    }
                    default: {
                        return $st("grid_position_close_position_title");
                    }
                }
            }
            case interfaces_1.AdjustParamsType.pause: {
                return $st("grid_position_pause_title");
            }
            case interfaces_1.AdjustParamsType.resume: {
                return $st("grid_position_resume_title");
            }
            case interfaces_1.AdjustParamsType.adjust_params: {
                return $st("grid_futures_adjust_price_range_result_title");
            }
            case interfaces_1.AdjustParamsType.sell_to_usdt: {
                return $st("grid_position_sell_to_usdt_title");
            }
            case interfaces_1.AdjustParamsType.share_ratio: {
                return $st("grid_position_share_ratio_title");
            }
            case interfaces_1.AdjustParamsType.update_leverage: {
                return $st("grid_futures_leverage_info_title");
            }
            case interfaces_1.AdjustParamsType.bonus_back: {
                return $st("grid_futures_bot_bonus_back_title");
            }
            case interfaces_1.AdjustParamsType.open_buy_quote: {
                return $st("grid_futures_open_position_agent_title");
            }
            default:
                return "";
        }
    })();
    const isClose = item.type === interfaces_1.AdjustParamsType.close;
    const isManualAppend = item.type === interfaces_1.AdjustParamsType.sell_to_usdt || item.type === interfaces_1.AdjustParamsType.share_ratio;
    const params = (() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
        const value = [];
        switch (item.type) {
            case interfaces_1.AdjustParamsType.pause: {
                value.push({
                    title: $st("grid_position_pause_position"),
                    value: (_a = $num(item.base_amount || 0) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay)) !== null && _a !== void 0 ? _a : "",
                });
                value.push({
                    title: $st("grid_position_pause_price"),
                    value: (_b = $num(item.avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _b !== void 0 ? _b : "",
                });
                return value;
            }
            case interfaces_1.AdjustParamsType.resume: {
                value.push({
                    title: $st("grid_position_resume_price"),
                    value: (_c = $num(item.avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _c !== void 0 ? _c : "",
                });
                return value;
            }
            case interfaces_1.AdjustParamsType.adjust_params: {
                const baseAmount = new trade_utils_lib_1.SafeDecimal(item.base_amount);
                if (baseAmount.gt(0)) {
                    value.push({
                        title: $st("grid_futures_adjust_price_range_result_increase_base_title", { base: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay }),
                        value: $num(baseAmount.toString() || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }),
                    });
                    value.push({
                        title: $st("grid_futures_adjust_price_range_result_increase_price_title"),
                        value: (_d = $num(item.avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _d !== void 0 ? _d : "",
                    });
                }
                if (baseAmount.lt(0)) {
                    value.push({
                        title: $st("grid_futures_adjust_price_range_result_decrease_base_title", { base: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay }),
                        value: $num(baseAmount.abs().toString() || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }),
                    });
                    value.push({
                        title: $st("grid_futures_adjust_price_range_result_decrease_price_title"),
                        value: (_e = $num(item.avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _e !== void 0 ? _e : "",
                    });
                }
                value.push({
                    title: $st("grid_futures_adjust_price_range_change_title"),
                    value: (_f = $num(item.new_bottom || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) +
                        "-" +
                        $num(item.new_top || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) +
                        " " +
                        (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _f !== void 0 ? _f : "",
                });
                value.push({
                    title: $st("grid_futures_adjust_price_range_row_title"),
                    value: $num(item.new_row || 0),
                });
                return value;
            }
            case interfaces_1.AdjustParamsType.close: {
                switch (order.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid: {
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.hedge) {
                            value.push({
                                title: $st("hedge_gird_close_position_quantity"),
                                value: $num(item.long_base_amount || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay),
                            });
                            value.push({
                                title: $st("close_position_avg_price"),
                                value: $num(item.long_avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                            });
                            return value;
                        }
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.long) {
                            value.push({
                                title: $st("hedge_gird_close_position_quantity"),
                                value: $num(item.long_base_amount || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay),
                            });
                            value.push({
                                title: $st("close_position_avg_price"),
                                value: $num(item.long_avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                            });
                            return value;
                        }
                        else {
                            value.push({
                                title: $st("hedge_gird_close_position_quantity"),
                                value: $num(item.short_base_amount || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay),
                            });
                            value.push({
                                title: $st("close_position_avg_price"),
                                value: $num(item.short_avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                            });
                            return value;
                        }
                    }
                    default: {
                        value.push({
                            title: (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay) + " " + $st("gf_close_position_quantity"),
                            value: $num(trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(new trade_utils_lib_1.SafeDecimal(item.base_amount || 0), symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount, trade_utils_lib_1.SafeDecimal.ROUND_DOWN), { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }) +
                                " " +
                                (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay),
                        });
                        value.push({
                            title: (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay) + " " + $st("gf_close_position_avg_price"),
                            value: $num(item.avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                        });
                        return value;
                    }
                }
            }
            case interfaces_1.AdjustParamsType.sell_to_usdt: {
                value.push({
                    title: $st("grid_position_gf_transaction_auto_sold_amount", { quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay }),
                    value: $num(item.quote_amount_sell || 0) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                });
                value.push({
                    title: $st("gf_transaction_auto_sold_price", { quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay }),
                    value: $num(item.quote_sell_price || 0, { precision: quoteUsdtSymbolInfo === null || quoteUsdtSymbolInfo === void 0 ? void 0 : quoteUsdtSymbolInfo.precision }) +
                        " " +
                        (quoteUsdtSymbolInfo === null || quoteUsdtSymbolInfo === void 0 ? void 0 : quoteUsdtSymbolInfo.quoteDisplay),
                });
                return value;
            }
            case interfaces_1.AdjustParamsType.share_ratio: {
                value.push({
                    title: $st("grid_position_share_ratio_percent"),
                    value: trade_utils_lib_1.NumberCommonUtils.toPercent(new trade_utils_lib_1.SafeDecimal((_g = order.exchangeGridV4FuturesOrder) === null || _g === void 0 ? void 0 : _g.share_ratio).mul(100), false),
                });
                value.push({
                    title: $st("grid_position_origin_profit"),
                    value: ShareRatioUtils_1.ShareRatioUtils.shareRatioFormat(new trade_utils_lib_1.SafeDecimal((_h = order.exchangeGridV4FuturesOrder) === null || _h === void 0 ? void 0 : _h.shared_profit)
                        .div(new trade_utils_lib_1.SafeDecimal((_j = order.exchangeGridV4FuturesOrder) === null || _j === void 0 ? void 0 : _j.share_ratio).equals(0)
                        ? 1
                        : new trade_utils_lib_1.SafeDecimal((_k = order.exchangeGridV4FuturesOrder) === null || _k === void 0 ? void 0 : _k.share_ratio))
                        .toNumber(), $num) +
                        " " +
                        (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                });
                value.push({
                    title: $st("grid_position_share_profit"),
                    value: ShareRatioUtils_1.ShareRatioUtils.shareRatioFormat(((_l = order.exchangeGridV4FuturesOrder) === null || _l === void 0 ? void 0 : _l.shared_profit) || 0, $num) +
                        " " +
                        (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                });
                return value;
            }
            case interfaces_1.AdjustParamsType.open: {
                switch (order.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid: {
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.hedge) {
                            // 做多方向
                            value.push({
                                title: $st("grid_futures_real_invest"),
                                value: (_m = $num(item.long_quote_investment || 0, {
                                    precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision,
                                }) +
                                    " " +
                                    (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _m !== void 0 ? _m : "",
                            });
                            value.push({
                                title: $st("trade_open_position_amount"),
                                value: (_o = $num(item.long_base_amount || 0, {
                                    precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount,
                                }) +
                                    " " +
                                    (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay)) !== null && _o !== void 0 ? _o : "",
                            });
                            value.push({
                                title: $st("trade_open_position_agv_price"),
                                value: (_p = $num(item.long_avg_price || 0, {
                                    precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision,
                                }) +
                                    " " +
                                    (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _p !== void 0 ? _p : "",
                            });
                            return value;
                        }
                        const extraMarginItem = {
                            title: $st("grid_futures_dynamic_margin"),
                            value: (_q = $num(item.extra_margin || 0, {
                                precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision,
                            }) +
                                " " +
                                (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _q !== void 0 ? _q : "",
                        };
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.long) {
                            // 做多方向
                            value.push({
                                title: $st("grid_futures_real_invest"),
                                value: (_r = $num(item.long_quote_investment || 0, {
                                    precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision,
                                }) +
                                    " " +
                                    (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _r !== void 0 ? _r : "",
                            });
                            value.push(extraMarginItem);
                            value.push({
                                title: $st("trade_open_position_amount"),
                                value: (_s = $num(item.long_base_amount || 0, {
                                    precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount,
                                }) +
                                    " " +
                                    (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay)) !== null && _s !== void 0 ? _s : "",
                            });
                            value.push({
                                title: $st("trade_open_position_agv_price"),
                                value: (_t = $num(item.long_avg_price || 0, {
                                    precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision,
                                }) +
                                    " " +
                                    (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _t !== void 0 ? _t : "",
                            });
                            return value;
                        }
                        else {
                            // 做空方向
                            value.push({
                                title: $st("grid_futures_real_invest"),
                                value: (_u = $num(item.short_quote_investment || 0, {
                                    precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision,
                                }) +
                                    " " +
                                    (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _u !== void 0 ? _u : "",
                            });
                            value.push(extraMarginItem);
                            value.push({
                                title: $st("trade_open_position_amount"),
                                value: (_v = $num(item.short_base_amount || 0, {
                                    precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount,
                                }) +
                                    " " +
                                    (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay)) !== null && _v !== void 0 ? _v : "",
                            });
                            value.push({
                                title: $st("trade_open_position_agv_price"),
                                value: (_w = $num(item.short_avg_price || 0, {
                                    precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision,
                                }) +
                                    " " +
                                    (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _w !== void 0 ? _w : "",
                            });
                            return value;
                        }
                    }
                    default: {
                        break;
                    }
                }
                if ((_x = order.exchangeGridV4FuturesOrder) === null || _x === void 0 ? void 0 : _x.locked_order) {
                    value.push({
                        title: $st("trade_investment"),
                        value: (_y = $num(item.invest_amount) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _y !== void 0 ? _y : "",
                    });
                    value.push({
                        title: $st("trade_open_position_amount"),
                        value: $num(item.base_amount || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay),
                    });
                    value.push({
                        title: $st("trade_open_position_agv_price"),
                        value: $num(item.avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                    });
                    return value;
                }
                break;
            }
            case interfaces_1.AdjustParamsType.invest_in: {
                if ((_z = order.exchangeGridV4FuturesOrder) === null || _z === void 0 ? void 0 : _z.locked_order) {
                    value.push({
                        title: $st("trade_investment"),
                        value: (_0 = $num(item.invest_amount) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _0 !== void 0 ? _0 : "",
                    });
                    value.push({
                        title: $st("trade_open_position_amount"),
                        value: $num(item.base_amount || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay),
                    });
                    value.push({
                        title: $st("trade_open_position_agv_price"),
                        value: $num(item.avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                    });
                    return value;
                }
                break;
            }
            case interfaces_1.AdjustParamsType.invest_out: {
                value.push({
                    title: $st("gf_reduce_position_list_investment"),
                    value: (_1 = $num(item.quote_investment || 0) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _1 !== void 0 ? _1 : "",
                });
                value.push({
                    title: $st("gf_reduce_position_list_grid_profit"),
                    value: (_2 = $num(item.grid_profit_out || 0) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _2 !== void 0 ? _2 : "",
                });
                value.push({
                    title: $st("gf_reduce_position_list_pnl"),
                    value: (_3 = $num(item.float_profit_out || 0) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _3 !== void 0 ? _3 : "",
                });
                value.push({
                    title: $st("grid_futures_reduce_position_amount"),
                    value: $num(item.base_amount || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay),
                });
                value.push({
                    title: $st("grid_futures_reduce_position_avg_price"),
                    value: $num(item.avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                });
                // value.push({
                //     title: $st("close_position_profit"),
                //     value: $num(item.profit_in_reduce || 0, { precision: symbolInfo?.precision }) + " " + symbolInfo?.quoteDisplay,
                // });
                return value;
            }
            case interfaces_1.AdjustParamsType.update_leverage: {
                value.push({
                    title: $st("grid_futures_leverage_before_title"),
                    value: $st("grid_futures_leverage_detail", { leverage: item.old_leverage }),
                });
                value.push({
                    title: $st("grid_futures_leverage_after_title"),
                    value: $st("grid_futures_leverage_detail", { leverage: item.new_leverage }),
                });
                return value;
            }
            case interfaces_1.AdjustParamsType.bonus_back: {
                value.push({
                    title: $st("grid_futures_bot_bonus_back_title"),
                    value: (_5 = $num(item.bonus_back_usdt) + " " + ((_4 = order.exchangeGridV4FuturesOrder) === null || _4 === void 0 ? void 0 : _4.invest_coin)) !== null && _5 !== void 0 ? _5 : "",
                });
                value.push({
                    title: $st("grid_futures_bot_bonus_put_out_title"),
                    value: (_7 = $num(item.bonus_investment) + " " + ((_6 = order.exchangeGridV4FuturesOrder) === null || _6 === void 0 ? void 0 : _6.invest_coin)) !== null && _7 !== void 0 ? _7 : "",
                });
                return value;
            }
            case interfaces_1.AdjustParamsType.open_buy_quote: {
                value.push({
                    title: $st("grid_futures_open_position_agent_buy_amount_label", { quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay }),
                    value: $num(new trade_utils_lib_1.SafeDecimal(item.invest_amount).add(new trade_utils_lib_1.SafeDecimal(item.buy_quote_fee).toFixed()), {
                        precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost,
                    }) +
                        " " +
                        (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                });
                value.push({
                    title: $st("grid_futures_open_position_agent_buy_price_label", { quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay }),
                    value: $num(new trade_utils_lib_1.SafeDecimal(item.buy_quote_price), {
                        precision: quoteUsdtSymbolInfo === null || quoteUsdtSymbolInfo === void 0 ? void 0 : quoteUsdtSymbolInfo.precision,
                    }) +
                        " " +
                        (quoteUsdtSymbolInfo === null || quoteUsdtSymbolInfo === void 0 ? void 0 : quoteUsdtSymbolInfo.quoteDisplay),
                });
                return value;
            }
        }
        !isManualAppend &&
            !isClose &&
            value.push({
                title: $st("grid_futures_real_invest"),
                value: (_8 = $num(item.quote_investment || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _8 !== void 0 ? _8 : "",
            });
        !isManualAppend &&
            item.extra_margin &&
            Number(item.extra_margin) &&
            value.push({
                title: $st("grid_futures_dynamic_margin"),
                value: (_9 = $num(item.extra_margin || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _9 !== void 0 ? _9 : "",
            });
        !isManualAppend &&
            value.push({
                title: isClose ? $st("close_position_quantity") : $st("trade_open_position_amount"),
                value: $num(item.base_amount || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay),
            });
        // 中性网格 开仓时不展示 开仓均价
        if (((_10 = order.exchangeGridV4FuturesOrder) === null || _10 === void 0 ? void 0 : _10.trend) !== TradeAPILib_1.GridFuturesTrend.no_trend ||
            item.type !== interfaces_1.AdjustParamsType.open ||
            !isManualAppend) {
            value.push({
                title: isClose ? $st("close_position_avg_price") : $st("trade_open_position_agv_price"),
                value: $num(item.avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
            });
        }
        return value;
    })();
    const paramsExtra = (() => {
        var _a, _b, _c;
        const value = [];
        switch (item.type) {
            case interfaces_1.AdjustParamsType.open: {
                switch (order.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid: {
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.hedge) {
                            // 做空方向
                            value.push({
                                title: $st("grid_futures_real_invest"),
                                value: (_a = $num(item.short_quote_investment || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) +
                                    " " +
                                    (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _a !== void 0 ? _a : "",
                            });
                            value.push({
                                title: $st("trade_open_position_amount"),
                                value: (_b = $num(item.short_base_amount || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay)) !== null && _b !== void 0 ? _b : "",
                            });
                            value.push({
                                title: $st("trade_open_position_agv_price"),
                                value: (_c = $num(item.short_avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) +
                                    " " +
                                    (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _c !== void 0 ? _c : "",
                            });
                            return value;
                        }
                        break;
                    }
                    default: {
                        break;
                    }
                }
                break;
            }
            case interfaces_1.AdjustParamsType.close: {
                switch (order.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid: {
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.hedge) {
                            value.push({
                                title: $st("hedge_gird_close_position_quantity"),
                                value: $num(item.short_base_amount || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay),
                            });
                            value.push({
                                title: $st("close_position_avg_price"),
                                value: $num(item.short_avg_price || 0, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay),
                            });
                            return value;
                        }
                        break;
                    }
                    default: {
                        break;
                    }
                }
                break;
            }
        }
        return undefined;
    })();
    const investParams = (() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
        switch (item.type) {
            case interfaces_1.AdjustParamsType.open: {
                switch (order.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid: {
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.hedge) {
                            return (_a = $num(item.invest_amount, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _a !== void 0 ? _a : "";
                        }
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.long) {
                            return ((_b = $num(item.long_quote_investment, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _b !== void 0 ? _b : "");
                        }
                        return ((_c = $num(item.short_quote_investment, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _c !== void 0 ? _c : "");
                    }
                    default: {
                        if ((_d = order.exchangeGridV4FuturesOrder) === null || _d === void 0 ? void 0 : _d.locked_order) {
                            return ((_e = $st("grid_position_trans_in") + " " + $num(item.init_usdt_investment) + " " + item.invest_coin) !== null && _e !== void 0 ? _e : exports.LOCKED_QUOTE);
                        }
                        return (_f = $num(item.invest_amount, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost }) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _f !== void 0 ? _f : "";
                    }
                }
            }
            case interfaces_1.AdjustParamsType.adjust_params: {
                if ((_g = order.exchangeGridV4FuturesOrder) === null || _g === void 0 ? void 0 : _g.locked_order) {
                    return ((_j = $st("grid_position_trans_in") +
                        " " +
                        $num((_h = item.invest_amount) !== null && _h !== void 0 ? _h : "", { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost }) +
                        " " +
                        item.invest_coin) !== null && _j !== void 0 ? _j : exports.LOCKED_QUOTE);
                }
                if (new trade_utils_lib_1.SafeDecimal(item.invest_amount).gt(0)) {
                    return ((_l = $st("grid_futures_trans_in_adjust_params") +
                        " " +
                        $num((_k = item.invest_amount) !== null && _k !== void 0 ? _k : "", { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost }) +
                        " " +
                        (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _l !== void 0 ? _l : "");
                }
                return "";
            }
            case interfaces_1.AdjustParamsType.sell_to_usdt: {
                const res = `${$st("grid_position_get")} ${trade_utils_lib_1.NumberCommonUtils.toNormalPrice(new trade_utils_lib_1.SafeDecimal(item.unlock_usdt_amount).add((_m = item.bonus_back_usdt) !== null && _m !== void 0 ? _m : 0))} ${quoteUsdtSymbolInfo === null || quoteUsdtSymbolInfo === void 0 ? void 0 : quoteUsdtSymbolInfo.quoteDisplay}\n+ ${trade_utils_lib_1.NumberCommonUtils.toNormalPrice(new trade_utils_lib_1.SafeDecimal(item.unlock_quote_amount))} ${symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay}`;
                // 仅当TO_USDT关单后又获得了少许Quote时，显示小额资产兑换入口
                if (new trade_utils_lib_1.SafeDecimal(item.unlock_quote_amount).gt(0)) {
                    subExtra = true;
                }
                else {
                    subExtra = false;
                }
                return res;
            }
            case interfaces_1.AdjustParamsType.share_ratio: {
                if (item.close_sell_model === TradeAPILib_1.BotOrderCloseModel.TO_USDT) {
                    return `${$st("grid_position_get")} ${$num(new trade_utils_lib_1.SafeDecimal(item.unlock_quote_amount).add(new trade_utils_lib_1.SafeDecimal(item.quote_amount_sell)).toNumber())} ${(_o = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay) !== null && _o !== void 0 ? _o : ""}`;
                }
                else {
                    return `${$st("grid_position_get")} ${$num(new trade_utils_lib_1.SafeDecimal(item.unlock_quote_amount).add(new trade_utils_lib_1.SafeDecimal(item.bonus_back_usdt)).toNumber())} ${(_p = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay) !== null && _p !== void 0 ? _p : ""}`;
                }
            }
            case interfaces_1.AdjustParamsType.close: {
                switch (order.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.gridV4Futures: {
                        if (((_q = order.exchangeGridV4FuturesOrder) === null || _q === void 0 ? void 0 : _q.close_sell_model) === TradeAPILib_1.BotOrderCloseModel.TO_USDT) {
                            return `${$st("grid_position_get")} ${$num(new trade_utils_lib_1.SafeDecimal(item.unlock_quote_amount)
                                .add(new trade_utils_lib_1.SafeDecimal(item.quote_amount_sell))
                                .add(new trade_utils_lib_1.SafeDecimal((_r = order.exchangeGridV4FuturesOrder) === null || _r === void 0 ? void 0 : _r.shared_profit))
                                .toNumber())} ${(_s = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay) !== null && _s !== void 0 ? _s : ""}`;
                        }
                        else {
                            return `${$st("grid_position_get")} ${$num(new trade_utils_lib_1.SafeDecimal(item.unlock_quote_amount)
                                .add(new trade_utils_lib_1.SafeDecimal((_t = order.exchangeGridV4FuturesOrder) === null || _t === void 0 ? void 0 : _t.shared_profit))
                                .add(new trade_utils_lib_1.SafeDecimal((_u = order.exchangeGridV4FuturesOrder) === null || _u === void 0 ? void 0 : _u.bonus_back_usdt))
                                .toNumber())} ${(_v = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay) !== null && _v !== void 0 ? _v : ""}`;
                        }
                    }
                    default: {
                        return (_w = $num(item.invest_amount) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _w !== void 0 ? _w : "";
                    }
                }
            }
            case interfaces_1.AdjustParamsType.invest_in: {
                if ((_x = order.exchangeGridV4FuturesOrder) === null || _x === void 0 ? void 0 : _x.locked_order) {
                    return (_y = $st("grid_position_trans_in") + " " + $num(item.usdt_invest) + " " + item.invest_coin) !== null && _y !== void 0 ? _y : exports.LOCKED_QUOTE;
                }
                return (_z = $num(item.invest_amount) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _z !== void 0 ? _z : "";
            }
            case interfaces_1.AdjustParamsType.invest_out: {
                return (_0 = $st("gf_reduce_posttion_list_content") + " " + $num(item.invest_amount) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _0 !== void 0 ? _0 : "";
            }
            case interfaces_1.AdjustParamsType.update_leverage: {
                const q = new trade_utils_lib_1.SafeDecimal(item.quote_investment);
                if (q.gt(0)) {
                    return $st("grid_futures_leverage_change_invest_change_in", { invest: $num(q), quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay });
                }
                else if (q.lt(0)) {
                    return $st("grid_futures_leverage_change_invest_change_out", {
                        invest: $num(q.mul(-1)),
                        quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay,
                    });
                }
                else {
                    if (new trade_utils_lib_1.SafeDecimal(item.old_leverage).gt(new trade_utils_lib_1.SafeDecimal(item.new_leverage))) {
                        return $st("grid_futures_leverage_change_invest_change_in", { invest: $num(q), quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay });
                    }
                    return $st("grid_futures_leverage_change_invest_change_out", {
                        invest: $num(q),
                        quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay,
                    });
                }
            }
            case interfaces_1.AdjustParamsType.bonus_back: {
                return `${$st("grid_position_get")} ${$num(new trade_utils_lib_1.SafeDecimal(item.unlock_usdt_amount).toString())} USDT`;
            }
            case interfaces_1.AdjustParamsType.open_buy_quote: {
                return `${$st("grid_futures_open_position_agent_value", {
                    amount: $num(item.invest_amount, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost }),
                    quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay,
                })}`;
            }
            default: {
                return (_1 = $num(item.invest_amount) + " " + (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay)) !== null && _1 !== void 0 ? _1 : "";
            }
        }
    })();
    const subTitleParams = (() => {
        switch (item.type) {
            case interfaces_1.AdjustParamsType.adjust_params: {
                const baseAmount = new trade_utils_lib_1.SafeDecimal(item.base_amount);
                const investAmount = new trade_utils_lib_1.SafeDecimal(item.invest_amount);
                if (baseAmount.eq(0)) {
                    if (item.status === "success") {
                        return $st("grid_futures_adjust_price_range_result_unchanged");
                    }
                    else {
                        /**
                         * 备注，服务端返回的错误码，拼接后可选的有如下几个选项
                         *
                         * grid_futures_per_volume_hit_amount_min
                         * grid_futures_per_volume_hit_amount_max
                         * grid_futures_unreinvest_less_than_original_investment_amount
                         */
                        const key = "grid_futures_";
                        return item.error ? $st(`${key}${item.error}`) : $st("grid_futures_adjust_price_range_failed");
                    }
                }
                if (baseAmount.abs().gt(0) && investAmount.gt(0)) {
                    return $st("grid_futures_adjust_price_range_result_add_position");
                }
                return "";
            }
            case interfaces_1.AdjustParamsType.sell_to_usdt: {
                if (new trade_utils_lib_1.SafeDecimal(item.unlock_quote_amount).gt(0)) {
                    return $st("strategy_copy_close_order_back_des_1", {
                        coins: `${trade_utils_lib_1.NumberCommonUtils.toNormalPrice(item.unlock_quote_amount)} ${symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay}`,
                    });
                }
                return "";
            }
            case interfaces_1.AdjustParamsType.invest_out: {
                if (item.invest_out_target === "BOT") {
                    return $st("gf_reduce_position_return_list_to_bot_tip");
                }
                return "";
            }
            case interfaces_1.AdjustParamsType.update_leverage: {
                if (item.status === "success" && new trade_utils_lib_1.SafeDecimal(item.quote_investment).lt(0)) {
                    return $st("grid_futures_leverage_info_subTitle");
                }
                return "";
            }
            default: {
                return "";
            }
        }
    })();
    const extraMargin = (() => {
        switch (item.type) {
            case interfaces_1.AdjustParamsType.open: {
                switch (order.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid: {
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.hedge) {
                            return {
                                title: $st("grid_futures_dynamic_margin"),
                                value: `${item.extra_margin || "--"}  ${symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay}`,
                            };
                        }
                        return undefined;
                    }
                    default: {
                        return undefined;
                    }
                }
            }
            default: {
                return undefined;
            }
        }
    })();
    const paramsTitle = (() => {
        switch (item.type) {
            case interfaces_1.AdjustParamsType.close:
            case interfaces_1.AdjustParamsType.open: {
                switch (order.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid: {
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.hedge) {
                            return useShortTitle ? $st("future_position_long") : $st("hedge_grid_add_bot_long");
                        }
                        return "";
                    }
                    default: {
                        return "";
                    }
                }
            }
            default: {
                return "";
            }
        }
    })();
    const paramsExtraTitle = (() => {
        switch (item.type) {
            case interfaces_1.AdjustParamsType.close:
            case interfaces_1.AdjustParamsType.open: {
                switch (order.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid: {
                        if (item.hedge_type === interfaces_1.GridHedgeFuturesHedgeType.hedge) {
                            return useShortTitle ? $st("future_position_short") : $st("hedge_grid_add_bot_short");
                        }
                        return "";
                    }
                    default: {
                        return "";
                    }
                }
            }
            default:
                return "";
        }
    })();
    return Object.assign(Object.assign({}, item), { invest: investParams, typeTitle: typeTitle, paramsTitle: paramsTitle, subTitle: subTitleParams, subExtra: subExtra, paramsDisplay: params, paramsExtraTitle: paramsExtraTitle, paramsExtraDisplay: paramsExtra, extraMargin: extraMargin });
};
exports.parseRenderAdjustItem = parseRenderAdjustItem;
const useRenderAdjustItem = (order, items, symbolInfo, $st, $num, quoteUsdtSymbolInfo, useShortTitle) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    const newItems = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
        const originItems = [...items];
        const index = originItems.findIndex((item) => item.type === interfaces_1.AdjustParamsType.close);
        if (index >= 0) {
            const containShareRatio = new trade_utils_lib_1.SafeDecimal((_a = order.exchangeGridV4FuturesOrder) === null || _a === void 0 ? void 0 : _a.share_ratio).greaterThan(0);
            originItems[index].close_sell_model = (_c = (_b = order.originOrderData) === null || _b === void 0 ? void 0 : _b.bu_order_data) === null || _c === void 0 ? void 0 : _c.close_sell_mode;
            originItems[index].unlock_quote_amount = (_e = (_d = order.originOrderData) === null || _d === void 0 ? void 0 : _d.bu_order_data) === null || _e === void 0 ? void 0 : _e.unlock_quote_amount;
            originItems[index].quote_amount_sell = (_g = (_f = order.originOrderData) === null || _f === void 0 ? void 0 : _f.bu_order_data) === null || _g === void 0 ? void 0 : _g.quote_amount_sell;
            if (containShareRatio) {
                originItems.unshift({
                    type: interfaces_1.AdjustParamsType.share_ratio,
                    avg_price: null,
                    base_amount: null,
                    create_time: originItems[index].create_time,
                    extra_margin: null,
                    invest_amount: "",
                    invest_coin: "",
                    quote_investment: null,
                    status: "success",
                    close_sell_model: (_h = order.exchangeGridV4FuturesOrder) === null || _h === void 0 ? void 0 : _h.close_sell_model,
                    bonus_back_usdt: (_k = (_j = order.originOrderData) === null || _j === void 0 ? void 0 : _j.bu_order_data) === null || _k === void 0 ? void 0 : _k.bonus_back_usdt,
                    unlock_quote_amount: (_m = (_l = order.originOrderData) === null || _l === void 0 ? void 0 : _l.bu_order_data) === null || _m === void 0 ? void 0 : _m.unlock_quote_amount,
                    quote_amount_sell: (_p = (_o = order.originOrderData) === null || _o === void 0 ? void 0 : _o.bu_order_data) === null || _p === void 0 ? void 0 : _p.quote_amount_sell,
                });
            }
            const isToUsdt = ((_q = order.exchangeGridV4FuturesOrder) === null || _q === void 0 ? void 0 : _q.close_sell_model) === TradeAPILib_1.BotOrderCloseModel.TO_USDT;
            if (isToUsdt) {
                originItems.unshift({
                    type: interfaces_1.AdjustParamsType.sell_to_usdt,
                    avg_price: null,
                    base_amount: null,
                    create_time: originItems[index].create_time,
                    extra_margin: null,
                    invest_amount: "",
                    invest_coin: "",
                    quote_investment: null,
                    status: "success",
                    bonus_back_usdt: (_s = (_r = order.originOrderData) === null || _r === void 0 ? void 0 : _r.bu_order_data) === null || _s === void 0 ? void 0 : _s.bonus_back_usdt,
                    quote_amount_sell: (_u = (_t = order.originOrderData) === null || _t === void 0 ? void 0 : _t.bu_order_data) === null || _u === void 0 ? void 0 : _u.quote_amount_sell,
                    quote_sell_price: (_w = (_v = order.originOrderData) === null || _v === void 0 ? void 0 : _v.bu_order_data) === null || _w === void 0 ? void 0 : _w.quote_sell_price,
                    baseAmount: (_x = originItems[index].base_amount) !== null && _x !== void 0 ? _x : undefined,
                    quoteAmount: (_z = (_y = order.originOrderData) === null || _y === void 0 ? void 0 : _y.bu_order_data) === null || _z === void 0 ? void 0 : _z.quote_amount_before_sell,
                    close_sell_model: TradeAPILib_1.BotOrderCloseModel.TO_USDT,
                    unlock_usdt_amount: (_1 = (_0 = order.originOrderData) === null || _0 === void 0 ? void 0 : _0.bu_order_data) === null || _1 === void 0 ? void 0 : _1.unlock_usdt_amount,
                    unlock_quote_amount: (_3 = (_2 = order.originOrderData) === null || _2 === void 0 ? void 0 : _2.bu_order_data) === null || _3 === void 0 ? void 0 : _3.unlock_quote_amount,
                });
            }
            // 发财金订单在关单后 需要展示一条回收发财金的记录
            const isBonusOrderClose = ((_4 = order.exchangeGridV4FuturesOrder) === null || _4 === void 0 ? void 0 : _4.investment_from) === TradeAPILib_1.GridFuturesInvestmentFrom.FUTURE_GRID_BONUS;
            if (isBonusOrderClose) {
                originItems.unshift({
                    type: interfaces_1.AdjustParamsType.bonus_back,
                    avg_price: null,
                    base_amount: null,
                    create_time: originItems[index].create_time,
                    extra_margin: null,
                    invest_amount: "",
                    invest_coin: "",
                    quote_investment: null,
                    status: "success",
                    unlock_usdt_amount: (_5 = order.exchangeGridV4FuturesOrder) === null || _5 === void 0 ? void 0 : _5.unlock_usdt_amount,
                    bonus_back_quote: (_6 = order.exchangeGridV4FuturesOrder) === null || _6 === void 0 ? void 0 : _6.bonus_back_quote,
                    bonus_back_usdt: (_7 = order.exchangeGridV4FuturesOrder) === null || _7 === void 0 ? void 0 : _7.bonus_back_usdt,
                    bonus_investment: (_8 = order.exchangeGridV4FuturesOrder) === null || _8 === void 0 ? void 0 : _8.usdt_investment,
                });
            }
        }
        return originItems;
    }, [
        items,
        (_a = order.exchangeGridV4FuturesOrder) === null || _a === void 0 ? void 0 : _a.bonus_back_quote,
        (_b = order.exchangeGridV4FuturesOrder) === null || _b === void 0 ? void 0 : _b.bonus_back_usdt,
        (_c = order.exchangeGridV4FuturesOrder) === null || _c === void 0 ? void 0 : _c.close_sell_model,
        (_d = order.exchangeGridV4FuturesOrder) === null || _d === void 0 ? void 0 : _d.investment_from,
        (_e = order.exchangeGridV4FuturesOrder) === null || _e === void 0 ? void 0 : _e.share_ratio,
        (_f = order.exchangeGridV4FuturesOrder) === null || _f === void 0 ? void 0 : _f.unlock_usdt_amount,
        (_g = order.exchangeGridV4FuturesOrder) === null || _g === void 0 ? void 0 : _g.usdt_investment,
        (_j = (_h = order.originOrderData) === null || _h === void 0 ? void 0 : _h.bu_order_data) === null || _j === void 0 ? void 0 : _j.bonus_back_usdt,
        (_l = (_k = order.originOrderData) === null || _k === void 0 ? void 0 : _k.bu_order_data) === null || _l === void 0 ? void 0 : _l.quote_amount_before_sell,
        (_o = (_m = order.originOrderData) === null || _m === void 0 ? void 0 : _m.bu_order_data) === null || _o === void 0 ? void 0 : _o.quote_amount_sell,
        (_q = (_p = order.originOrderData) === null || _p === void 0 ? void 0 : _p.bu_order_data) === null || _q === void 0 ? void 0 : _q.quote_sell_price,
        (_s = (_r = order.originOrderData) === null || _r === void 0 ? void 0 : _r.bu_order_data) === null || _s === void 0 ? void 0 : _s.unlock_quote_amount,
        (_u = (_t = order.originOrderData) === null || _t === void 0 ? void 0 : _t.bu_order_data) === null || _u === void 0 ? void 0 : _u.unlock_usdt_amount,
    ]);
    return (0, react_1.useMemo)(() => {
        return newItems.map((item) => (0, exports.parseRenderAdjustItem)(order, item, symbolInfo, $st, $num, quoteUsdtSymbolInfo, useShortTitle));
    }, [$num, $st, quoteUsdtSymbolInfo, newItems, order, symbolInfo, useShortTitle]);
};
exports.useRenderAdjustItem = useRenderAdjustItem;
